// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '@/views/HomePage.vue';
import AboutPage from '@/views/AboutPage.vue';
import AnalysisTool from '@/views/AnalysisTool.vue';
import AnalysisToolV2 from '@/views/AnalysisToolV2.vue';
import AnalysisToolQA from '@/views/AnalysisToolQA.vue';
import AddressMatchTool from '@/views/AddressMatchTool.vue';
import LinkCheckTool from '@/views/LinkCheckTool.vue';
import TxnHistoryInterpreter from '@/views/TxnHistoryInterpreter.vue';
import TxnPurchaseSummary from '@/views/TxnPurchaseSummary.vue';
import TxnHistoryInterpreterDev from '@/views/TxnHistoryInterpreterDev.vue';
import ViewImage from '@/views/ViewImage.vue';
import UserViewImage from '@/views/UserViewImage.vue';
import AdminViewImage from '@/views/AdminViewImage.vue';
import LoginPage from '@/views/LoginPage.vue';
import ToolGuide from '@/views/ToolGuide.vue';
import DisclaimerPage from '@/views/DisclaimerPage.vue';
import AuthService from '@/services/AuthService';
import HelpPage from '@/views/HelpPage';
import BugReports from '@/views/BugReports';
import AccessDenied from '@/views/AccessDenied';
import PasswordReset from '@/views/PasswordReset';
import AccountPage from '@/views/AccountPage';
import SetupPassword from '@/views/SetupPassword.vue';
import SetupAccount from '@/views/SetupAccount.vue';
import SignupPage from '@/views/SignupPage.vue';
import SignupFlow from '@/views/SignupFlow.vue';
import AdminUserJourneys from '@/views/AdminUserJourneys.vue';
import BasicTutorial from '@/views/BasicTutorial.vue';
import AdminPage from '@/views/AdminPage.vue';
import SecurityPanel from '@/views/SecurityPanel.vue';
import ModSecurityPanel from '@/views/ModSecurityPanel.vue';
import SecurityTools from '@/views/SecurityTools.vue';
import SupportPage from '@/views/SupportPage.vue';
import ModeratorPage from '@/views/ModeratorPage.vue';
import TokenMetadataAdmin from '@/views/TokenMetadataAdmin.vue';
import RequestMonitor from '@/views/RequestMonitor.vue';
import SignupReview from '@/views/SignupReview.vue';
import SupportTicketManager from '@/views/SupportTicketManager.vue';
import SignupHistory from '@/views/SignupHistory.vue';
import RequestInvestigation from '@/views/RequestInvestigation.vue';
import TermsOfService from '@/views/TermsOfService.vue';
import PrivacyPolicy from '@/views/PrivacyPolicy.vue';
import CreditLoader from '@/views/CreditLoader.vue';
import PaymentComplete from '@/views/PaymentComplete.vue';
import PaymentCompletePage from '@/views/PaymentCompletePage.vue';
import PaymentCompleteOld from '@/views/PaymentCompleteOld.vue';
import UserAccountManager from '@/views/UserAccountManager.vue';
import StripeProductChooser from '@/views/StripeProductChooser.vue';
import ProductChooserTest from '@/views/ProductChooserTest.vue';
import ProductChooserLiveTest from '@/views/ProductChooserLiveTest.vue';
import PaymentCancelled from '@/views/PaymentCancelled.vue';
import PaymentCancelledPage from '@/views/PaymentCancelledPage.vue';
import DeleteAccount from '@/views/DeleteAccount.vue';
import FairUsePolicy from '@/views/FairUsePolicy.vue';
import AdminHQImages from '@/views/AdminHQImages.vue';
import PromoCodeManager from '@/views/PromoCodeManager.vue';
import PromoCodeManagerNew from '@/views/PromoCodeManagerNew.vue';
import AdminSignupsDashboard from '@/views/AdminSignupsDashboard.vue';
import CasePrepBuddy from '@/views/CasePrepBuddy';

import CaseBuddy from '@/views/CaseBuddy.vue';


const routes = [
  { path: '/', name: 'home', component: HomePage, meta: { requiresAuth: true } },
  { path: '/about', name: 'about', component: AboutPage, meta: { requiresAuth: true } },
 { path: '/AnalysisTool', name: 'AnalysisTool', component: AnalysisTool, meta: { requiresAuth: true  } },
 { path: '/AnalysisToolV2', name: 'AnalysisToolV2', component: AnalysisToolV2, meta: { requiresAuth: true  } },
 { path: '/AnalysisToolQA', name: 'AnalysisToolQA', component: AnalysisToolQA, meta: { requiresAuth: true, requiresAdmin: true  } },
 { path: '/AddressMatchTool', name: 'AddressMatchTool', component: AddressMatchTool, meta: { requiresAuth: true  } },
 { path: '/LinkCheckTool', name: 'LinkCheckTool', component: LinkCheckTool, meta: { requiresAuth: true  } },
 { path: '/TxnHistoryInterpreter', name: 'TxnHistoryInterpreter', component: TxnHistoryInterpreter, meta: { requiresAuth: true, disallowRestricted: true  } },
  { path: '/TxnPurchaseSummary', name: 'TxnPurchaseSummary', component: TxnPurchaseSummary, meta: { requiresAuth: true  } },
  { path: '/TxnHistoryInterpreterDev', name: 'TxnHistoryInterpreterDev', component: TxnHistoryInterpreterDev, meta: { requiresAuth: true, disallowRestricted: true  } },
 { path: '/BasicTutorial', name: 'BasicTutorial', component: BasicTutorial, meta: { requiresAuth: true  } },
 { path: '/load-credits', name: 'CreditLoader', component: CreditLoader, meta: { requiresAuth: true  } },
  { path: '/products', name: 'StripeProductChooser', component: StripeProductChooser, meta: { requiresAuth: true  } },
{ path: '/ProductChooserTest', name: 'ProductChooserTest', component: ProductChooserTest, meta: { requiresAuth: true  } },
{ path: '/ProductChooserLiveTest', name: 'ProductChooserLiveTest', component: ProductChooserLiveTest, meta: { requiresAuth: true  } },
 { path: '/payment-complete', name: 'PaymentComplete', component: PaymentComplete, meta: { requiresAuth: true  } },
 { path: '/payment-cancelled', name: 'PaymentCancelled', component: PaymentCancelled, meta: { requiresAuth: true  } },
 { path: '/payment-complete-page', name: 'PaymentCompletePage', component: PaymentCompletePage, meta: { requiresAuth: true  } },
 { path: '/payment-cancelled-page', name: 'PaymentCancelledPage', component: PaymentCancelledPage, meta: { requiresAuth: true  } },
 { path: '/delete-account', name: 'DeleteAccount', component: DeleteAccount,  meta: {
    requiresAuth: true,
    disallowRoles: ['admin', 'moderator']
  } },
 { path: '/payment-complete-old', name: 'PaymentCompleteOld', component: PaymentCompleteOld, meta: { requiresAuth: true  } },
  { path: '/HelpPage', name: 'HelpPage', component: HelpPage, meta: { requiresAuth: true } },
  { path: '/ToolGuide', name: 'ToolGuide', component: ToolGuide, meta: { requiresAuth: true } },
  { path: '/DisclaimerPage', name: 'DisclaimerPage', component: DisclaimerPage, meta: { requiresAuth: false } },
  { path: '/BugReports', name: 'BugReports', component: BugReports, meta: { requiresAuth: true, requiresAdmin: true } },
  { path: '/ViewImage/:requestID', name: 'ViewImage', props: true, component: ViewImage, meta: { requiresAuth: true } },
  { path: '/UserViewImage/:requestID', name: 'UserViewImage', props: true, component: UserViewImage, meta: { requiresAuth: true } },
  {
  path: '/AdminViewImage/:requestID',
  name: 'AdminViewImage',
  component: AdminViewImage,
  props: true,
  meta: { requiresAuth: true, requiresAdminOrModerator: true }
},
{
  path: '/case-prep-buddy',
  name: 'CasePrepBuddy',
  component: CasePrepBuddy,
  meta: { requiresAuth: true, disallowRestricted: true }
},

{
  path: '/casebuddy',
  name: 'casebuddy',
  component: CaseBuddy,
  meta: {
    requiresAuth: true,
   disallowRestricted: true,
   requiresAdminOrModerator: true
  }
},



{
  path: '/csv-helper-v2',
  name: 'TxnHistoryInterpreterV2',
  component: () => import('@/views/TxnHistoryInterpreterV2.vue'),
  meta: {
    requiresAuth: true,
    disallowRestricted: true,
  },
},
{
  path: '/analysis-v2/batch/:batchUuid',
  name: 'AnalysisToolV2BatchProcessor',
  component: () => import('@/views/V2BatchProcessor.vue'),
  meta: {
    requiresAuth: true,
    disallowRestricted: true,
  },
},

{
  path: '/analysis-v2/request/:requestUuid',
  name: 'AnalysisToolV2Processor',
  component: () => import('@/views/V2RequestProcessor.vue'),
  meta: {
    requiresAuth: true,
    disallowRestricted: true,
  },
},


  { path: '/login', name: 'login', component: LoginPage, meta: { hideLoginNavLoginLink: true } },
  { path: '/access-denied', name: 'accessDenied', component: AccessDenied },
  { path: '/password-reset', name: 'PasswordReset', component: PasswordReset, meta: { requiresAuth: true } },
  { path: '/RequestInvestigation', name: 'RequestInvestigation', component: RequestInvestigation, meta: { requiresAuth: true } },
  { path: '/account-page', name: 'AccountPage', component: AccountPage, meta: { requiresAuth: true } },
  { path: '/support', name: 'SupportPage', component: SupportPage, meta: { requiresAuth: true } },
  { path: '/SetupPassword', name: 'SetupPassword', component: SetupPassword, meta: { requiresAuth: false } },
   { path: '/SetupAccount', name: 'SetupAccount', component: SetupAccount, meta: { requiresAuth: false } },
  { path: '/signup', name: 'SignupFlow', component: SignupFlow, meta: { requiresAuth: false } },
   { path: '/signupflow', name: 'SignupPage', component: SignupPage, meta: { requiresAuth: false } },
    { path: '/terms', name: 'TermsOfService', component: TermsOfService, meta: { requiresAuth: false } },
    { path: '/fair-use-policy', name: 'FairUsePolicy', component: FairUsePolicy, meta: { requiresAuth: false } },
      { path: '/privacy', name: 'PrivacyPolicy', component: PrivacyPolicy, meta: { requiresAuth: false } },
  { path: '/admin', name: 'admin', component: AdminPage, meta: { requiresAuth: true, requiresAdmin: true } },
  { path: '/securitypanel', name: 'securitypanel', component: SecurityPanel, meta: { requiresAuth: true, requiresAdmin: true } },
  { path: '/AdminUserJourneys', name: 'AdminUserJourneys', component: AdminUserJourneys, meta: { requiresAuth: true, requiresAdmin: true } },
  { path: '/modsecuritypanel', name: 'modsecuritypanel', component: ModSecurityPanel, meta: { requiresAuth: true, requiresAdminOrModerator: true } },
  { path: '/requestmonitor', name: 'requestmonitor', component: RequestMonitor, meta: { requiresAuth: true, requiresAdminOrModerator: true } },
   { path: '/signupreview', name: 'signupreview', component: SignupReview, meta: { requiresAuth: true, requiresAdminOrModerator: true } },
   { path: '/adminhqimages', name: 'AdminHQImages', component: AdminHQImages, meta: { requiresAuth: true, requiresAdminOrModerator: true } },
   { path: '/supporttickets', name: 'supporttickets', component: SupportTicketManager, meta: { requiresAuth: true, requiresAdminOrModerator: true } },
   { path: '/useraccounts', name: 'UserAccountManager', component: UserAccountManager, meta: { requiresAuth: true, requiresAdminOrModerator: true } },
  { path: '/signuphistory', name: 'signuphistory', component: SignupHistory, meta: { requiresAuth: true, requiresAdminOrModerator: true } },
  { path: '/securitytools', name: 'securitytools', component: SecurityTools, meta: { requiresAuth: true, requiresAdminOrModerator: true } },
  { path: '/moderator', name: 'moderator', component: ModeratorPage, meta: { requiresAuth: true, requiresAdminOrModerator: true } },
  { path: '/PromoCodeManager', name: 'PromoCodeManager', component: PromoCodeManager, meta: { requiresAuth: true, requiresAdminOrModerator: true } },
   { path: '/PromoCodeManagerNew', name: 'PromoCodeManagerNew', component: PromoCodeManagerNew, meta: { requiresAuth: true, requiresAdminOrModerator: true } },
   { path: '/AdminSignupsDashboard', name: 'AdminSignupsDashboard', component: AdminSignupsDashboard, meta: { requiresAuth: true, requiresAdminOrModerator: true } },
  { path: '/tokenmetadata', name: 'tokenmetadata', component: TokenMetadataAdmin, meta: { requiresAuth: true, requiresAdmin: true } },
{
  path: '/supporttickets/ticket/:ticketId',
  name: 'SupportTicketDirectView',
  component: SupportTicketManager,
  props: true,
  meta: { requiresAuth: true, requiresAdminOrModerator: true }
}


];

// Router/session replacement section.
//
// Keep the existing imports, routes, and createRouter configuration that appear
// above this section in your real router file. Replace the current getSessionId,
// logPageview, beforeEach, and afterEach blocks with the code below.

function getSessionId() {
  let sid = sessionStorage.getItem('sid');

  if (!sid) {
    const bytes = new Uint8Array(16);
    crypto.getRandomValues(bytes);
    sid = Array.from(bytes)
      .map(value => value.toString(16).padStart(2, '0'))
      .join('');
    sessionStorage.setItem('sid', sid);
  }

  return sid;
}

export async function logPageview(to, from) {
  const token = localStorage.getItem('token') || '';
  const verifiedSession = AuthService.getVerifiedSessionSnapshot();

  // Analytics does not make an authentication decision. It uses only a session
  // that login or verify.php has already established. This prevents a second
  // verify.php call during every navigation and avoids forwarding an unverified
  // or damaged localStorage token through the analytics request.
  const isAuthed = !!(
    token &&
    verifiedSession &&
    verifiedSession.isAuthenticated === true
  );

  const payload = {
    route_name: to?.name || null,
    path: to?.fullPath || to?.path || null,
    from_route: from?.name || null,
    ts: Date.now(),
    session_id: getSessionId(),

    // Retained for current track_pageview.php compatibility, but only after
    // the same token has already been verified in this browser session.
    jwt: isAuthed ? token : null,
    authed: isAuthed,
  };

  const url = '/api/etherscan/track_pageview.php';

  try {
    if (isAuthed) {
      await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
        keepalive: true,
      });

      return;
    }

    const blob = new Blob(
      [JSON.stringify(payload)],
      { type: 'application/json' }
    );

    if (navigator.sendBeacon) {
      navigator.sendBeacon(url, blob);
    } else {
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
        keepalive: true,
      }).catch(() => {});
    }
  } catch (error) {
    // Analytics must never block or redirect navigation.
    console.debug('logPageview failed (non-blocking):', error);
  }
}

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  if (!to.matched.some(record => record.meta.requiresAuth)) {
    return next();
  }

  AuthService.getUserRole()
    .then(({ role, isRestricted }) => {
      if (!role) {
        return next({ name: 'login' });
      }

      if (
        to.matched.some(record => record.meta.disallowRestricted) &&
        isRestricted
      ) {
        return next({ name: 'accessDenied' });
      }

      if (to.matched.some(record => record.meta.requiresAdmin)) {
        return role === 'admin'
          ? next()
          : next({ name: 'accessDenied' });
      }

      if (
        to.matched.some(
          record => record.meta.requiresAdminOrModerator
        )
      ) {
        return role === 'admin' || role === 'moderator'
          ? next()
          : next({ name: 'accessDenied' });
      }

      const disallowedRoles = to.matched.flatMap(record => (
        Array.isArray(record.meta.disallowRoles)
          ? record.meta.disallowRoles
          : []
      ));

      if (disallowedRoles.includes(role)) {
        return next({ name: 'accessDenied' });
      }

      return next();
    })
    .catch(() => next({ name: 'login' }));
});

router.afterEach((to, from) => {
  window.__lastRouteName = to?.name || null;

  try {
    void logPageview(to, from);
  } catch (error) {
    console.debug('logPageview invocation failed:', error);
  }
});

export default router;
